export const initialSystemControls = {
        "ioopt": 3,
        "maxit": 600,
        "weapon": 1,
        "nmerit": 1,
        "fix_wt": 1.5,
        "con_wt": 1.0,
        "zero_wt": 10.0,
        "viol_wt": 1.0,
        "mfn_wt": 0.01,
        "objmin": 0.00001,
        "del": 1.0,
        "delmin": 0.0001,
        "tol": 0.0001,
        "smallnum": 1.0e-07,
        "show_units": 1,
        "show_violations": 1,
        "enable_auto_fix": 1,
        "enable_auto_search": 1
    };
